export default __webpack_public_path__ + "static/constat_nl-d3688c55ca7d2c92956e575396ee83f9.mp4";